export default __webpack_public_path__ + "static/ria davey-6319c8c2da175c71ce0acf81583e1081.png";